import {
  SourcingService,
  SourcingSetting,
  SourcingSettingUpdateParameters,
} from 'api-clients/monolith';

type UpdateSourcingSettingsParams = Partial<SourcingSetting>;

export function updateSourcingSettings(params: UpdateSourcingSettingsParams) {
  const requestBody: SourcingSettingUpdateParameters = {
    sourcing_setting: {
      budget_automation_enabled: params.budget_automation_enabled,
      funnel_automation_enabled: params.funnel_automation_enabled,
      hiring_automation_enabled: params.hiring_automation_enabled,
      default_metrics_period: params.default_metrics_period,
    },
  };

  return SourcingService.patchInternalApiSourcingSourcingSettings(requestBody);
}
